<template>
  <div>
    <h2 class="d-flex justify-center" v-if="message">{{ message }}</h2>
    <iframe
      v-if="id"
      :src="`${baseUrl}company/view/${id}`"
      frameborder="0"
      width="100%"
      height="700"
    ></iframe>
  </div>
</template>
<script>
import { URL } from "@/api/config";
export default {
  data: () => ({
    id: "",
    baseUrl: "",
  }),
  created() {
    this.baseUrl = URL;
    this.message = "Aguarde.. Carregando ficha empresa";
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.message = "";
    }
  },
};
</script>

<style scoped>
iframe {
  display: block; /* iframes are inline by default */
  background: #000;
  border: none; /* Reset default border */
  height: 90vh; /* Viewport-relative units */
  width: 98vw;
}
</style>
